module.exports = __webpack_public_path__ + "static/media/1.05a64aa8.jpg";